import { API } from 'aws-amplify';

export const updateSkillContent = async (params: { skillId: string; content: string | null }) => {
  const apiName = process.env.NEXT_PUBLIC_ACADEMICS_API_NAME!;
  const path = 'api/skill-content/content';
  return await API.put(apiName, path, { body: params });
};
